import { DataStream, MerchantChannelReport } from '../../interfaces'

export enum MerchantsChannelsTypes {
  VIEW_MERCHANT_CHANNEL_PAYMENTS_REQUEST = '@@merchant-channels/VIEW_MERCHANT_CHANNEL_PAYMENTS_REQUEST',
  VIEW_MERCHANT_CHANNEL_PAYMENTS_SUCCESS = '@@merchant-channels/VIEW_MERCHANT_CHANNEL_PAYMENTS_SUCCESS',
  VIEW_MERCHANT_CHANNEL_PAYMENTS_FAILURE = '@@merchant-channels/VIEW_MERCHANT_CHANNEL_PAYMENTS_FAILURE',
  EXPORT_MERCHANT_CHANNEL_PAYMENTS_REQUEST = '@@merchant-channels/EXPORT_MERCHANT_CHANNEL_PAYMENTS_REQUEST',
  EXPORT_MERCHANT_CHANNEL_PAYMENTS_SUCCESS = '@@merchant-channels/EXPORT_MERCHANT_CHANNEL_PAYMENTS_SUCCESS',
  EXPORT_MERCHANT_CHANNEL_PAYMENTS_FAILURE = '@@merchant-channels/EXPORT_MERCHANT_CHANNEL_PAYMENTS_FAILURE',
  CLEAR_CHANNELS = '@@merchant-channels/CLEAR_CHANNELS'
}

export type MerchantsChannelsState = {
  readonly channels: MerchantChannelReport | null
  readonly loading: boolean
  readonly merchantChannelError: any
  readonly merchantChannelExportError: any
  readonly isExporting: boolean
  readonly isExportSuccess: boolean
  readonly isExportError: boolean
  readonly exportStream: DataStream | undefined
}
